import * as React from 'react'
import Helmet from 'react-helmet'

import * as logo from "./../assets/banner.png"
import * as fb_icon from "./../assets/FBicon.png"
import * as goog_icon from "./../assets/Gicon.png"
import * as houzz_icon from "./../assets/Hicon.png"

import Navigator from "./../components/navbar"

import './../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './index.css'

const Header = () => (
  <div id="header"
    style={{
      marginBottom: '1.45rem',
      textAlign: 'center',
      height: '140px',
      width: '100%',
    }}
  >
    <div style={{
      position: 'relative', 
      display: 'flex',
      flexWrap: 'nowrap', 
      margin: 'auto', 
      width: '100%', 
      height: '100%',
      whiteSpace: 'nowrap',
      justifyContent: 'center',
    }}>
      <div 
        style={{
          display: 'inline-block',
          padding: '1.45rem 1.0875rem',
          height: '100%',
        }}
      >
        <h1 style={{
            display: 'inline-block',
          }}>
          <a
            href="/"
          >
            <img id='logo' src={logo} alt="Logo" width="327" height="89"/>
          </a>
        </h1>
      </div>
      <div
        style={{
          display: 'inline-block',
          paddingTop: '60px',
          flexShrink: 0,
        }}
      >
        <Navigator />
      </div>
    </div>
  </div>
)

const Footer = () => (
  <footer className='footer-font'>
    <div style={{
      right: '0',
      bottom: '0',
      left: '0',
      backgroundColor: 'rgba(55,55,55,0.6)',
      width: '100%',
      height: 'auto',
      marginBottom: '0px',
      textAlign: 'center',
      color: 'white',
    }}>
      <div style={{
        backgroundColor: 'rgba(30,30,30,0.6)',
        width: '100%',
        height: 'auto',
        paddingTop: '8px',
        paddingBottom: '6px',
      }}>
        <div style={{
          display: 'block',
          fontSize: '13px',
          fontWeight: 'bold',
          zIndex: 1,
        }}>
          <a href='/' style={{color: 'white',textDecoration: 'none',}}>HOME </a>|
          <a href='/about-us/' style={{color: 'white',textDecoration: 'none',}}> ABOUT </a>|
          <a href='/services/' style={{color: 'white',textDecoration: 'none',}}> SERVICE </a>|
          <a href='/gallery-la/' style={{color: 'white',textDecoration: 'none',}}> GALLERY </a>|
          <a href='/contact-us/' style={{color: 'white',textDecoration: 'none',}}> CONTACT</a>
        </div>
        <div style={{
          display: 'block',
          fontFamily: 'Helvetica',
          fontSize: '11px',
          fontWeight: 'lighter',
          paddingLeft: '10px',
          paddingRight: '10px',
        }}>
          Toll free 866.482.8665 | Bay Area 408.412.3892 | Sacramento 916.368.8898 | Fax 916.368.8899 | 9921 Horn Road, Sacramento, CA 95827 | info@underjuniper.com
        </div>
      </div>
      <div style={{
        display: 'block',
        fontSize: '22px',
        marginTop: '8px',
        marginBottom: '5px',
      }}>
        <a href="https://www.facebook.com/Under-Juniper-Inc-268384103354575/">
          <img src={fb_icon} alt="FacebookIcon" width="25" height="25"/>
        </a>
        &nbsp;
        <a href="https://www.houzz.com/pro/underjuniper/under-juniper-inc">
          <img src={houzz_icon} alt="HouzzIcon" width="25" height="25"/>
        </a>
        &nbsp;
        <a href="https://www.google.com/maps/place/Under+Juniper+Inc/@38.576373,-121.325128,15z/data=!4m2!3m1!1s0x0:0x1c96a46441ca372b?sa=X&ved=0ahUKEwiu9u31tuvZAhUFKqwKHWOwChoQ_BIIcjAK">
          <img src={goog_icon} alt="GoogleIcon" width="25" height="25"/>
        </a>
      </div>
      <div style={{
        display: 'block',
        fontFamily: 'Helvetica',
        fontSize: '12px',
        marginTop: '-13px',
        fontWeight: 'lighter',
        paddingBottom: '5px',
      }}>
        © 2017 Under Juniper Landscape & Development. All rights reserved.
      </div>
    </div>
  </footer>
)

class DefaultLayout extends React.Component {
  public render() {
    return (
      <div>
        <Helmet
          title="Under Juniper Inc."
          meta={[
            { name: 'description', content: 'Sample' },
            { name: 'keywords', content: 'sample, something' },
          ]}
        />
        <Header />
        <div
          style={{
            margin: '0 auto',
            maxWidth: 1085,
            padding: '0px 3rem 1.45rem',
            paddingTop: 0,
          }}
        >
          {this.props.children}
        </div>
        <Footer />
      </div>
    );
  }
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/layouts/index.tsx